import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "student/";

// 修改密码
export const studentModifyPassword = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "modifyPassword", {
    data: Qs.stringify(_params),
    method: "POST",
  });
};

// 修改用户基本信息
export const studentUpdateBase = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "updateBase", {
    data: _params,
    method: "POST",
  });
};
// 获取个人用户信息详情
export const studentGetProfile = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "getProfile", {
    data: _params,
    method: "GET",
  });
};
// 修改电子签名
export const updateSignature = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "updateSignature", {
    data: Qs.stringify(_params),
    method: "POST",
  });
};
// 校验电子签名
export const checkSignature = (params) => {
         return sendRequest(api.url + _base + "checkSignature", {
           data: params,
           method: "POST",
         });
       };
// 更改手机号码
export const updatePhone = (params) => {
         return sendRequest(api.url + _base + "updatePhone", {
           data: Qs.stringify(params),
           method: "POST",
         });
       };



// WEBPACK FOOTER //
// ./src/fetch/api/student.js